export default {
    apiKey: "AIzaSyCjpzR9ouYtgurHd15uwhssspOcySOjcG0",
    discoveryDocs: 
      ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    spreadsheetId: "1-C_tF1xfOCAlc-0qsra_DRYBDlKoRAMUxt6E4KJvRt8"
  };